import { Card, CardTitle } from 'reactstrap'
import PropTypes from 'prop-types'
import DiscountView from 'domains/voucher/molecules/discount-view'

const propTypes = {
  voucher: PropTypes.shape({
    id   : PropTypes.number.isRequired,
    code : PropTypes.string.isRequired,
    rule : PropTypes.object.isRequired
  }),
  onClick: PropTypes.func
}

const VoucherCard = ({
  voucher,
  onClick = () => { }
}) => {
  const rule = voucher.rule

  return (
    <Card
      body
      className='shadow mb-3 card-clickable'
      onClick={ () => onClick(voucher) }
      style={{ cursor: 'pointer' }}
    >

      <CardTitle>
        <div className='font-weight-bold'>{ rule.name }</div>
        <div className='text-muted'>{ rule.description }</div>
      </CardTitle>

      <DiscountView
        isActive={ rule.is_item_discount_active }
        discountOn={ 'Item Total' }
        discountType={ rule.item_discount_type }
        absolute={ rule.item_discount_absolute }
        percentage={ rule.item_discount_percentage }
        percentageMax={ rule.item_discount_percentage_max }
      />
      <DiscountView
        isActive={ rule.is_shipment_discount_active }
        discountOn={ 'Delivery Fee' }
        discountType={ rule.shipment_discount_type }
        absolute={ rule.shipment_discount_absolute }
        percentage={ rule.shipment_discount_percentage }
        percentageMax={ rule.shipment_discount_percentage_max }
      />
    </Card>
  )}

VoucherCard.propTypes = propTypes

export default VoucherCard